import { render, staticRenderFns } from "./AuthorModalFigure.vue?vue&type=template&id=57bf882f&"
import script from "./AuthorModalFigure.vue?vue&type=script&lang=ts&"
export * from "./AuthorModalFigure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports